import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import ServerAPI from '../ServerAPI';
import Promise from 'bluebird';

import {List, ListItem} from 'material-ui/List';

import Avatar from 'material-ui/Avatar';
import Business from 'material-ui/svg-icons/communication/business';
import Person from 'material-ui/svg-icons/social/person';
import {green500,blue500, orange500} from 'material-ui/styles/colors';

import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import Subheader from 'material-ui/Subheader';

// Lists customers and expands users from customer when clicked, allowing
// user selection to be made.
export default @observer
class CustomerUserList extends Component {

  // When the user clicks customer, we will fetch the set of users for
  // that company and expand the user list as a sublist under the customer
  loadUsersFor(customer) {
    return function() {
      customer.loadingUsers = true;
      AppModelUtils.fetch_userlist_for(customer)
      .finally(function(){
        customer.loadingUsers = false;
      });
    }
  }

  // When a user has been clicked - we return control to the component that
  // included the CustomerList on it's page.
  userSelected(id_customer,id_user) {
    var self = this;
    return function() {
      self.props.userSelected(id_customer,id_user);
    }
  }

  userLoadingItem() {
    var element = (
      <ListItem
          key={"dummykey"}
          value={"No value"}
          leftAvatar={ <Avatar icon={<Person />}
                               backgroundColor={green500} />}
          primaryText={uiMsg('CUL_LOADING_USERS',"Loading users ..")}
      />
    )
    return [element];
  }

  userItem(user) {
    return (
      <ListItem
        key={user.id_customer+user.id}
        onTouchTap={
          this.userSelected(user.id_customer,user.id).bind(this)
        }
        leftAvatar={ <Avatar icon={<Person />}
                             backgroundColor={green500} />}
        primaryText={(<div>{user.name}, (<b>{user.id}</b>)</div>)}
        secondaryText={user.email}
        />
    )
  }

  render() {
    var self = this;
    var customers = this.props.customers;
    return (
      <List>
        <Subheader>{uiMsg('CUL_SELECT_USER',"Select user to log in as")} :</Subheader> {
          customers.map(function(customer) { return (
            <ListItem
                key = {customer.id}
                value={customer.id}
                leftAvatar={ <Avatar icon={<Business />}
                                    backgroundColor={orange500} />}
                primaryText={customer.name}
                initiallyOpen={true}
                nestedItems={
                  customer.loadingUsers ? self.userLoadingItem() :
                  customer.users.map(self.userItem.bind(self))}
                onTouchTap={self.loadUsersFor(customer).bind(self)}
            />
        )})
      } </List>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/components/CustomerUserList.jsx
 **/